module.exports = __webpack_public_path__ + "d9c60a2da1475ac772b159739f4f0cd6.png";